import * as React from 'react'
import { ReactNode } from 'react'

const SidebarCard = ({ children }: { children: ReactNode }) => {
    return (
        <div className="bg-brand-grey050 w-full border-t border-black p-4">
            <div className="flex flex-col gap-y-4">{children}</div>
        </div>
    )
}

export default SidebarCard
